var componentRequireContext = require.context("components", true, /front\/search_page|front\/common\/FloatingPromotionBanner|youtube\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
